import React from 'react'
import cn from 'classnames'

import {
  Tile,
  TileOverlay,
  TileCaption,
  Button,
  useResponsiveHandler,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { segment, track } from '@mc/track-event'
import { usePrimaryCta } from '@mc/growth'

import { PricingText } from 'components/PricingText'

export const EndScreen = ({ pageType }: { pageType: string }) => {
  const { t } = useTranslation('@mc/next')
  const { ltSM } = useResponsiveHandler()
  const { ctaHref, ctaCopy } = usePrimaryCta()

  const trackPurchaseClick = () => {
    track(segment.EventTypes.PURCHASE_CLICK, {
      category: 'video-player',
      location: 'video-player',
      action: ctaCopy,
      href: ctaHref,
      page_type: pageType,
      class_type: 'camp',
    })
  }

  return (
    <Tile className='mc-h-100'>
      <TileOverlay type='solid' />
      <TileCaption
        position={ltSM ? 'center top' : 'center'}
        className={cn({ 'd-sm-flex': !ltSM })}
      >
        <h4
          className={cn(
            'mc-mb-2',
            { 'mc-text-h4': !ltSM },
            { 'mc-text-h6': ltSM },
          )}
        >
          {t('sessions.endScreen.title')}
        </h4>
        <p
          className={cn(
            { 'mc-mb-8': !ltSM },
            { 'mc-mb-2': ltSM },
            { 'mc-text-small': ltSM },
          )}
        >
          <PricingText />
        </p>
        <Button
          as='a'
          href={ctaHref}
          onClick={trackPurchaseClick}
          size={ltSM ? 'sm' : 'md'}
        >
          {ctaCopy}
        </Button>
      </TileCaption>
    </Tile>
  )
}
